import {
  CIMasterCreateFormState,
  CIMasterEditFormState,
  CIMasterRaw,
} from "@/domain/CIMaster";
import { API_CLIENT } from "../config";

const apiUrlCIMasters = "/admin/ci_masters";

/**
 * NOTE: ciMasterDocId は サーバが返した「エンコード済み」の doc_id 文字列
 * （例: "algo-artis%2Fspreadsheet-api-server"）。
 */
export const getAdminCIMasters = async (): Promise<CIMasterRaw[]> => {
  const response = await API_CLIENT.get<{ items: CIMasterRaw[] }>(
    apiUrlCIMasters
  );
  return response.data.items;
};

export const postAdminCreateCIMaster = async ({
  ciMasterCreateFormState,
}: {
  ciMasterCreateFormState: CIMasterCreateFormState;
}): Promise<CIMasterRaw> => {
  const response = await API_CLIENT.post<{ item: CIMasterRaw }>(
    apiUrlCIMasters,
    {
      ...ciMasterCreateFormState,
    }
  );
  return response.data.item;
};

export const postAdminEditCIMaster = async ({
  ciMasterDocId,
  ciMasterEditFormState,
}: {
  ciMasterDocId: string;
  ciMasterEditFormState: CIMasterEditFormState;
}): Promise<CIMasterRaw> => {
  const response = await API_CLIENT.post<{ item: CIMasterRaw }>(
    `${apiUrlCIMasters}/${ciMasterDocId}`,
    {
      ...ciMasterEditFormState,
    }
  );
  return response.data.item;
};

export const postAdminDisableCIMaster = async ({
  ciMasterDocId,
}: {
  ciMasterDocId: string;
}): Promise<void> => {
  await API_CLIENT.post(`${apiUrlCIMasters}/${ciMasterDocId}/delete`);
};

export const postAdminEnableCIMaster = async ({
  ciMasterDocId,
}: {
  ciMasterDocId: string;
}): Promise<void> => {
  await API_CLIENT.post(`${apiUrlCIMasters}/${ciMasterDocId}/enable`);
};

export const postAdminRemoveCIMaster = async ({
  ciMasterDocId,
}: {
  ciMasterDocId: string;
}): Promise<void> => {
  await API_CLIENT.post(`${apiUrlCIMasters}/${ciMasterDocId}/remove`);
};
